import React from 'react';
import './TablePagination.css';
import CustomSelect from '../CustomSelect/CustomSelect';

const TablePagination = ({
  totalItems,
  totalPages,
  itemsPerPage,
  itemsPerPageOptions,
  currentPage,
  setCurrentPage,
  setItemsPerPage,
  selectedItemsCount,
}) => {
  return (
    <div className='table-pagination'>
      <div className='table-pagination__info'>
        <div className='table-pagination__counter'>
          <span className='table-pagination__label'>Отмечено:&nbsp;</span>
          <span className='table-pagination__text'>
            <span className='table-pagination__selected'>
              {selectedItemsCount}
            </span>
            &nbsp;/&nbsp;
            <span className='table-pagination__total'>{totalItems}</span>
          </span>
        </div>
        <div className='table-pagination__total-items'>
          <span className='table-pagination__label'>Всего:</span>&nbsp;
          <span className='table-pagination__text'>{totalItems}</span>
        </div>
      </div>
      <div className='table-pagination__controls'>
        <div className='pagination__pages'>
          <span className='pagination__label'>Страницы: &nbsp; </span>
          <div className='pagination__list'>
            {[...Array(totalPages).keys()].map((page) => (
              <span
                key={page + 1}
                className={`pagination__page ${
                  currentPage === page + 1 ? 'pagination__page__active' : ''
                }`}
                onClick={() => setCurrentPage(page + 1)}
              >
                {page + 1}{' '}
              </span>
            ))}
          </div>
        </div>
        <div className='pagination__arrows'>
          <span
            className={`pagination__arrow pagination__arrow__prev ${
              currentPage === 1 ? 'disabled' : ''
            }`}
            onClick={() => setCurrentPage(Math.max(currentPage - 1, 1))}
          >
            {'< Предыдущая'}
          </span>

          <span
            className={`pagination__arrow pagination__arrow__next ${
              currentPage === totalPages ? 'disabled' : ''
            }`}
            onClick={() =>
              setCurrentPage(Math.min(currentPage + 1, totalPages))
            }
          >
            {'Следующая >'}
          </span>
        </div>
        <div className='table-pagination__limit'>
          <span className='table-pagination__label'>На странице:</span>
          <CustomSelect
            options={itemsPerPageOptions.map((option) => ({
              label: `${option}`,
              value: option,
            }))}
            value={itemsPerPage}
            onChange={(selectedOption) => {
              setItemsPerPage(selectedOption.value);
              setCurrentPage(1);
            }}
            className='table-pagination__select'
          />
        </div>
      </div>
    </div>
  );
};

export default TablePagination;
